import { Text } from "@rneui/themed";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { BottomSheetFlatList } from "@gorhom/bottom-sheet";
import { useBookmarksQuery } from "@annunciate/query";
import BookmarkListItem from "./BookmarkListItem";
import { NoteForm } from "./NoteForm";
export const BookmarkList = ({ content, initialEditItem, closeModal, }) => {
    const { data } = useBookmarksQuery(content.id);
    const [editItem, setEditItem] = useState(initialEditItem);
    const [shouldClose, setShouldClose] = useState(false);
    useEffect(() => {
        if (editItem)
            setShouldClose(true);
    }, []);
    useEffect(() => {
        if (!initialEditItem)
            return;
        setEditItem(initialEditItem);
    }, [initialEditItem]);
    if (!data?.length)
        return React.createElement(View, { style: { flexGrow: 1, justifyContent: 'center' } },
            React.createElement(Text, { style: {
                    width: '100%',
                    textAlign: 'center',
                    fontSize: 16,
                    padding: 24
                } }, "You haven't made any bookmarks for this item yet."));
    if (editItem) {
        return (React.createElement(NoteForm, { onClose: () => {
                setEditItem(undefined);
                shouldClose && closeModal && closeModal();
            }, onSubmitSuccess: () => setEditItem(undefined), bookmark: editItem }));
    }
    return (React.createElement(BottomSheetFlatList, { data: data || [], renderItem: ({ item }) => (React.createElement(BookmarkListItem, { item: item, content: content, onEdit: setEditItem, onFinish: closeModal, key: item.id })) }));
};
//# sourceMappingURL=BookmarkList.js.map